export default "__VITE_ASSET__aXOk8Y6I__"